import {useTranslation} from "react-i18next";

import Container from "../UI/Container";
import SectionHeader from "../UI/header/SectionHeader";
import ProjectCard from "../UI/block/card/ProjectCard";

import './OurProjectSection.sass';
import project1 from '../../assets/img/projects/project1.jpeg';
import project2 from '../../assets/img/projects/project2.png';
import project3 from '../../assets/img/projects/project3.jpeg';
import project4 from '../../assets/img/projects/project4.png';
import project6 from '../../assets/img/projects/project6.png';
import project7 from '../../assets/img/projects/project7.png';
import project9 from '../../assets/img/projects/project9.png';
import project10 from '../../assets/img/projects/project10.png';
import project11 from '../../assets/img/projects/project11.png';
import project12 from '../../assets/img/projects/project12.png';
import project13 from '../../assets/img/projects/project13.png';
import project14 from '../../assets/img/projects/project14.png';
import project15 from '../../assets/img/projects/project15.jpg';
import project16 from '../../assets/img/projects/project16.jpg';
import project17 from '../../assets/img/projects/project17.jpg';
import project18 from '../../assets/img/projects/project18.jpg';
import project19 from '../../assets/img/projects/project19.jpg';
import project20 from '../../assets/img/projects/project20.jpeg';
import project21 from '../../assets/img/projects/project21.jpeg';
import project22 from '../../assets/img/projects/project22.jpeg';
import project23 from '../../assets/img/projects/project23.jpeg';
import project24 from '../../assets/img/projects/project24.jpeg';
import project25 from '../../assets/img/projects/project25.jpeg';
import project26 from '../../assets/img/projects/project26.jpeg';
import project27 from '../../assets/img/projects/project27.jpeg';
import project28 from '../../assets/img/projects/project28.jpeg';
import project29 from '../../assets/img/projects/project29.jpeg';

const OurProjectsSection = (props) => {
    const { t } = useTranslation();

    return (
        <section className='our-projects' id='ourProjects' ref={props.sectionRef}>
            <Container>
                <SectionHeader header={t("ourProjects.header.title")}>
                    {t("ourProjects.header.description")}
                </SectionHeader>
                <div className='projects-grid'>
                    <ProjectCard
                        header={t("ourProjects.projects.project29.title")}
                        description={t("ourProjects.projects.project29.description")}
                        image={project29}
                        url='https://happyplants.me/'
                    />
                    <ProjectCard
                        header={t("ourProjects.projects.project28.title")}
                        description={t("ourProjects.projects.project28.description")}
                        image={project28}
                        url='https://avi-pflege.com/'
                    />
                    <ProjectCard
                        header={t("ourProjects.projects.project27.title")}
                        description={t("ourProjects.projects.project27.description")}
                        image={project27}
                        url='https://avento-mobility.de/'
                    />
                    <ProjectCard
                        header={t("ourProjects.projects.project26.title")}
                        description={t("ourProjects.projects.project26.description")}
                        image={project26}
                        url='https://onthespotfilmtransport.com/'
                    />
                    <ProjectCard
                        header={t("ourProjects.projects.project25.title")}
                        description={t("ourProjects.projects.project25.description")}
                        image={project25}
                        url='https://www.eatandevent.com'
                    />
                    <ProjectCard
                        header={t("ourProjects.projects.project24.title")}
                        description={t("ourProjects.projects.project24.description")}
                        image={project24}
                        url='https://borgoolistico.com/en'
                    />
                    <ProjectCard
                        header={t("ourProjects.projects.project15.title")}
                        description={t("ourProjects.projects.project15.description")}
                        image={project15}
                        url='https://gpartners.md/ro/'
                    />
                    <ProjectCard
                        header={t("ourProjects.projects.project18.title")}
                        description={t("ourProjects.projects.project18.description")}
                        image={project18}
                        url='https://work-o.com/'
                    />
                    <ProjectCard
                        header={t("ourProjects.projects.project23.title")}
                        description={t("ourProjects.projects.project23.description")}
                        image={project23}
                        url='https://advanced-lawyers.com'
                    />
                    <ProjectCard
                        header={t("ourProjects.projects.project22.title")}
                        description={t("ourProjects.projects.project22.description")}
                        image={project22}
                        url='https://eugenevanltd.uk'
                    />
                    <ProjectCard
                        header={t("ourProjects.projects.project21.title")}
                        description={t("ourProjects.projects.project21.description")}
                        image={project21}
                        url='https://connector-gmbh.com/'
                    />
                    <ProjectCard
                        header={t("ourProjects.projects.project20.title")}
                        description={t("ourProjects.projects.project20.description")}
                        image={project20}
                        url='https://aldetailing.de/'
                    />
                    <ProjectCard
                        header={t("ourProjects.projects.project19.title")}
                        description={t("ourProjects.projects.project19.description")}
                        image={project19}
                        url='https://moneybreeze.md/'
                    />
                    <ProjectCard
                        header={t("ourProjects.projects.project16.title")}
                        description={t("ourProjects.projects.project16.description")}
                        image={project16}
                        url='https://greenworldgbr.de/de/'
                    />
                    <ProjectCard
                        header={t("ourProjects.projects.project17.title")}
                        description={t("ourProjects.projects.project17.description")}
                        image={project17}
                    />
                    <ProjectCard
                        header={t("ourProjects.projects.project14.title")}
                        description={t("ourProjects.projects.project14.description")}
                        image={project14}
                        url='https://www.behance.net/gallery/178860351/Real-estate-consulting-branding-2023'
                    />
                    <ProjectCard
                        header={t("ourProjects.projects.project13.title")}
                        description={t("ourProjects.projects.project13.description")}
                        image={project13}
                        url='https://www.behance.net/gallery/192461415/soncept-of-corp-attributes-for-an-insurance-company'
                    />
                    <ProjectCard
                        header={t("ourProjects.projects.project1.title")}
                        description={t("ourProjects.projects.project1.description")}
                        image={project1}
                        url='https://blackmoto.md/'
                    />
                    <ProjectCard
                        header={t("ourProjects.projects.project3.title")}
                        description={t("ourProjects.projects.project3.description")}
                        image={project3}
                        url='https://torsedor.md/'
                    />
                    <ProjectCard
                        header={t("ourProjects.projects.project2.title")}
                        description={t("ourProjects.projects.project2.description")}
                        image={project2}
                    />
                    <ProjectCard
                        header={t("ourProjects.projects.project4.title")}
                        description={t("ourProjects.projects.project4.description")}
                        image={project4}
                    />
                    <ProjectCard
                        header={t("ourProjects.projects.project6.title")}
                        description={t("ourProjects.projects.project6.description")}
                        image={project6}
                        url='https://www.behance.net/gallery/179019961/Psychologist-landing-page-website'
                    />
                    <ProjectCard
                        header={t("ourProjects.projects.project7.title")}
                        description={t("ourProjects.projects.project7.description")}
                        image={project7}
                    />
                    <ProjectCard
                        header={t("ourProjects.projects.project9.title")}
                        description={t("ourProjects.projects.project9.description")}
                        image={project9}
                        url='https://www.behance.net/gallery/178467887/Branding-for-private-profiling-services'
                    />
                    <ProjectCard
                        header={t("ourProjects.projects.project10.title")}
                        description={t("ourProjects.projects.project10.description")}
                        image={project10}
                        url='https://www.behance.net/gallery/151443533/Premium-tabacco-branding-e-commerce-website'
                    />
                    <ProjectCard
                        header={t("ourProjects.projects.project11.title")}
                        description={t("ourProjects.projects.project11.description")}
                        image={project11}
                        url='https://www.behance.net/gallery/151380121/Medical-equipment-business-website-UIUX'
                    />
                    <ProjectCard
                        header={t("ourProjects.projects.project12.title")}
                        description={t("ourProjects.projects.project12.description")}
                        image={project12}
                        url='https://www.behance.net/gallery/159360229/Hoodie-Store-Identity'
                    />
                </div>
            </Container>
        </section>
    );
};

export default OurProjectsSection;